import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { Heading1 } from '@lightspeed/flame/Text';
import { themeGet } from '@styled-system/theme-get';

import { staticPath } from '~/renderer/utils';

import { StyledFullHeightFlex } from './TipInput';
import { TotalAmountBanner } from './TotalAmountBanner';

const StyledBackground = styled(Flex)`
  border-radius: ${themeGet('radii.radius-circle')};
  width: 350px;
  height: 350px;
  background: ${themeGet('colors.white')};
  justify-content: center;
`;

const StyledFlexWrapper = styled(Flex)`
  background-color: ${themeGet('colors.black')};
  width: 100vw;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: ${themeGet('lineHeights.9')};
`;

export const TerminalPayment: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledFullHeightFlex flexDirection="column">
      <TotalAmountBanner />
      <StyledFlexWrapper>
        <Flex flexDirection="column" alignItems="center">
          <Heading1 role="heading" color="white">
            {t('receipt.tipping.completePaymentTerminal')}
          </Heading1>
          <StyledBackground mt={8}>
            <img
              width="120px"
              alt={t('receipt.tipping.alt.paymentTerminal')}
              src={`${staticPath}/assets/tipping/p400-Verifone.svg`}
            />
          </StyledBackground>
        </Flex>
      </StyledFlexWrapper>
    </StyledFullHeightFlex>
  );
};
